<template>
    <div id="level-form">
        <v-card>
            <v-expansion-panels flat v-if="data">
                <v-expansion-panel
                    v-for="(row, i) in data"
                    :key="i"
                    class="mb-3"
                    style="border: 1.5px solid #f0f0f0; border-radius: 5px"
                >
                    <v-expansion-panel-header class="font-weight-bold">
                        Interpretasi {{ i + 1 }}
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                        <div>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title class="font-weight-500">
                                        <div>
                                            <v-btn
                                                @click="previewPage()"
                                                depressed
                                                class="font-weight-bold green--text mt-0 mb-3"
                                                color="#E2F5EA"
                                            >
                                                Preview
                                            </v-btn>
                                        </div>

                                        <div
                                            class="d-flex mb-5"
                                            style="
                                                align-items: center;
                                                justify-content: space-between;
                                            "
                                        >
                                            <div
                                                v-if="
                                                    detail_scale.question_type ===
                                                    'choice'
                                                "
                                            >
                                                <div
                                                    class="font-weight-600"
                                                    style="font-size: 14px"
                                                >
                                                    Kode Dominan
                                                </div>

                                                <div
                                                    class="font-weight-500 black60--text mt-1"
                                                    style="font-size: 14px"
                                                >
                                                    {{ row.most_value || "-" }}
                                                </div>
                                            </div>

                                            <div v-else>
                                                <div
                                                    class="font-weight-600"
                                                    style="font-size: 14px"
                                                >
                                                    Rentang Score
                                                </div>

                                                <div
                                                    class="font-weight-500 black60--text mt-1"
                                                    style="font-size: 14px"
                                                >
                                                    {{ row.min_result || 0 }} -
                                                    {{ row.max_result || 0 }}
                                                </div>
                                            </div>

                                            <div>
                                                <v-btn
                                                    depressed
                                                    color="#e2f0f7"
                                                    class="primary--text mr-8"
                                                    x-small
                                                    height="40"
                                                    @click="editRange(row)"
                                                >
                                                    <v-icon
                                                        style="font-size: 20px"
                                                    >
                                                        mdi-pencil
                                                    </v-icon>
                                                </v-btn>
                                            </div>
                                        </div>

                                        <div>
                                            <v-card
                                                v-if="!row.pages.length"
                                                outlined
                                            >
                                                <v-card-text class="pa-3">
                                                    <div
                                                        class="d-flex"
                                                        style="
                                                            justify-content: space-between;
                                                            align-items: center;
                                                        "
                                                    >
                                                        <div
                                                            class="font-weight-600"
                                                        >
                                                            Page 1
                                                        </div>
                                                        <div>
                                                            <v-btn
                                                                text
                                                                @click="
                                                                    addInterpretation(
                                                                        row
                                                                    )
                                                                "
                                                                depressed
                                                                class="font-weight-bold blew--text mt-0"
                                                                style="
                                                                    margin-right: auto;
                                                                "
                                                                color="#e8f5fa"
                                                            >
                                                                <v-icon
                                                                    style="
                                                                        font-size: 16px !important;
                                                                    "
                                                                    class="mr-1"
                                                                >
                                                                    mdi-plus-circle
                                                                </v-icon>
                                                                Tambah Jenis
                                                                Interpretasi
                                                            </v-btn>
                                                        </div>
                                                    </div>
                                                </v-card-text>
                                            </v-card>

                                            <v-card
                                                v-for="(
                                                    page, index
                                                ) in row.pages"
                                                :key="index"
                                                color="#f9fafc"
                                                flat
                                                class="mt-5"
                                            >
                                                <v-card-text class="pa-5">
                                                    <div
                                                        class="d-flex"
                                                        style="
                                                            justify-content: space-between;
                                                            align-items: center;
                                                            padding-top: -10px;
                                                            padding-bottom: 7px;
                                                        "
                                                    >
                                                        <div
                                                            class="font-weight-bold"
                                                        >
                                                            Page {{ index + 1 }}
                                                        </div>

                                                        <div
                                                            v-if="
                                                                index + 1 !== 1
                                                            "
                                                        >
                                                            <v-btn
                                                                text
                                                                @click="
                                                                    addSubInterpretation(
                                                                        index +
                                                                            1,
                                                                        row
                                                                    )
                                                                "
                                                                depressed
                                                                class="font-weight-bold blew--text mt-0"
                                                                style="
                                                                    margin-right: auto;
                                                                "
                                                                color="#e8f5fa"
                                                                :disabled="
                                                                    page
                                                                        .sub_interpretation
                                                                        .length ===
                                                                    2
                                                                "
                                                            >
                                                                <v-icon
                                                                    style="
                                                                        font-size: 16px !important;
                                                                    "
                                                                    class="mr-1"
                                                                >
                                                                    mdi-plus-circle
                                                                </v-icon>
                                                                Tambah Sub
                                                                Interpretasi
                                                            </v-btn>
                                                        </div>
                                                    </div>

                                                    <div class="mt-2">
                                                        <div v-if="index === 0">
                                                            <v-card
                                                                outlined
                                                                v-for="(
                                                                    sub, i
                                                                ) in page.sub_interpretation"
                                                                :key="i"
                                                                class="mb-5"
                                                            >
                                                                <v-card-title>
                                                                    <span
                                                                        class="font-weight-bold"
                                                                        style="
                                                                            font-size: 14px;
                                                                        "
                                                                    >
                                                                        Interpretasi
                                                                    </span>
                                                                    <v-spacer />
                                                                    <v-btn
                                                                        depressed
                                                                        color="#e2f0f7"
                                                                        class="primary--text"
                                                                        x-small
                                                                        height="40"
                                                                        @click="
                                                                            editInterpretation(
                                                                                sub
                                                                            )
                                                                        "
                                                                    >
                                                                        <v-icon
                                                                            style="
                                                                                font-size: 20px;
                                                                            "
                                                                        >
                                                                            mdi-pencil
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </v-card-title>

                                                                <v-card-text>
                                                                    <div
                                                                        class="font-weight-600"
                                                                    >
                                                                        Judul
                                                                        Interpretasi
                                                                    </div>

                                                                    <div>
                                                                        {{
                                                                            sub.title
                                                                        }}
                                                                    </div>

                                                                    <div
                                                                        v-if="
                                                                            sub.icon
                                                                        "
                                                                    >
                                                                        <v-img
                                                                            :src="
                                                                                sub.icon
                                                                            "
                                                                            height="120"
                                                                            width="120"
                                                                            class="mt-3"
                                                                            style="
                                                                                border-radius: 5px;
                                                                            "
                                                                        />
                                                                    </div>

                                                                    <div
                                                                        class="font-weight-600 mt-3"
                                                                    >
                                                                        Deskripsi
                                                                    </div>

                                                                    <div
                                                                        v-html="
                                                                            sub.description
                                                                        "
                                                                    ></div>
                                                                </v-card-text>
                                                            </v-card>
                                                        </div>

                                                        <div v-else>
                                                            <v-card
                                                                outlined
                                                                v-for="(
                                                                    sub, i
                                                                ) in page.sub_interpretation"
                                                                :key="i"
                                                                class="mb-5"
                                                            >
                                                                <v-card-title>
                                                                    <span
                                                                        class="font-weight-bold"
                                                                        style="
                                                                            font-size: 14px;
                                                                        "
                                                                    >
                                                                        Sub
                                                                        Interpretasi
                                                                        {{
                                                                            i +
                                                                            1
                                                                        }}
                                                                    </span>
                                                                    <v-spacer />
                                                                    <v-btn
                                                                        depressed
                                                                        color="#e2f0f7"
                                                                        class="primary--text"
                                                                        x-small
                                                                        height="40"
                                                                        @click="
                                                                            editSubInterpretation(
                                                                                sub
                                                                            )
                                                                        "
                                                                    >
                                                                        <v-icon
                                                                            style="
                                                                                font-size: 20px;
                                                                            "
                                                                        >
                                                                            mdi-pencil
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </v-card-title>

                                                                <v-card-text>
                                                                    <div
                                                                        class="font-weight-600"
                                                                    >
                                                                        Judul
                                                                    </div>

                                                                    <div>
                                                                        {{
                                                                            sub.title
                                                                        }}
                                                                    </div>

                                                                    <div
                                                                        v-if="
                                                                            sub.icon
                                                                        "
                                                                    >
                                                                        <v-img
                                                                            :src="
                                                                                sub.icon
                                                                            "
                                                                            height="120"
                                                                            width="120"
                                                                            class="mt-3"
                                                                            style="
                                                                                border-radius: 5px;
                                                                            "
                                                                        />
                                                                    </div>

                                                                    <div
                                                                        class="font-weight-600 mt-3"
                                                                    >
                                                                        Deskripsi
                                                                    </div>

                                                                    <div
                                                                        v-html="
                                                                            sub.description
                                                                        "
                                                                    ></div>
                                                                </v-card-text>
                                                            </v-card>
                                                        </div>
                                                    </div>
                                                </v-card-text>
                                            </v-card>

                                            <v-card
                                                v-if="row.cta.length"
                                                color="#f9fafc"
                                                flat
                                                class="mt-5"
                                            >
                                                <v-card-text class="pa-5">
                                                    <div
                                                        class="d-flex"
                                                        style="
                                                            justify-content: space-between;
                                                            align-items: center;
                                                            margin-top: -5px;
                                                        "
                                                    >
                                                        <div
                                                            class="font-weight-600 pb-4 pt-1"
                                                        >
                                                            CTA
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <v-card
                                                            outlined
                                                            v-for="(
                                                                cta, i
                                                            ) in row.cta"
                                                            :key="i"
                                                            class="mb-5"
                                                        >
                                                            <v-card-title>
                                                                <v-row>
                                                                    <v-col
                                                                        cols="11"
                                                                    >
                                                                        <div
                                                                            style="
                                                                                font-size: 14px;
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="font-weight-bold"
                                                                                style="
                                                                                    text-transform: capitalize;
                                                                                "
                                                                            >
                                                                                {{
                                                                                    cta.cta_name ===
                                                                                    "prodi"
                                                                                        ? "Career Mapping"
                                                                                        : cta.cta_name
                                                                                }}
                                                                            </div>

                                                                            <div
                                                                                class="grey--text font-weight-500"
                                                                                style="
                                                                                    margin-top: -10px;
                                                                                "
                                                                            >
                                                                                {{
                                                                                    cta.cta_description
                                                                                }}
                                                                            </div>

                                                                            <div
                                                                                class="mt-5"
                                                                            >
                                                                                <v-row>
                                                                                    <v-col
                                                                                        v-for="(
                                                                                            data,
                                                                                            i
                                                                                        ) in cta.content"
                                                                                        :key="
                                                                                            i
                                                                                        "
                                                                                        cols="4"
                                                                                    >
                                                                                        <v-card
                                                                                            outlined
                                                                                            class="mb-5"
                                                                                        >
                                                                                            <v-card-text
                                                                                                class="pa-2"
                                                                                            >
                                                                                                <div
                                                                                                    class="d-flex"
                                                                                                    style="
                                                                                                        align-items: center;
                                                                                                        gap: 15px;
                                                                                                    "
                                                                                                >
                                                                                                    <div>
                                                                                                        <v-img
                                                                                                            :src="
                                                                                                                data.content_icon
                                                                                                            "
                                                                                                            width="39"
                                                                                                            height="39"
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div
                                                                                                        class="darkgrey--text"
                                                                                                    >
                                                                                                        {{
                                                                                                            data.content_name
                                                                                                        }}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </v-card-text>
                                                                                        </v-card>
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </div>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col>
                                                                        <v-btn
                                                                            depressed
                                                                            color="#e2f0f7"
                                                                            class="primary--text"
                                                                            x-small
                                                                            height="40"
                                                                            @click="
                                                                                editSubInterpretation(
                                                                                    cta
                                                                                )
                                                                            "
                                                                        >
                                                                            <v-icon
                                                                                style="
                                                                                    font-size: 20px;
                                                                                "
                                                                            >
                                                                                mdi-pencil
                                                                            </v-icon>
                                                                        </v-btn>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card-title>
                                                        </v-card>
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </div>

                                        <div class="mt-5">
                                            <v-btn
                                                @click="
                                                    addPage(
                                                        row.pages.length + 1,
                                                        row
                                                    )
                                                "
                                                depressed
                                                block
                                                :disabled="!row.pages.length"
                                                class="font-weight-bold blew--text mt-0 mb-3"
                                            >
                                                Tambah Page
                                            </v-btn>
                                        </div>
                                    </v-list-item-title>

                                    <div align="right" class="py-3">
                                        <v-btn
                                            text
                                            color="#868EA4"
                                            @click="confirmDeleteItem(row)"
                                        >
                                            <v-icon
                                                color="red"
                                                small
                                                class="mr-2"
                                                >mdi-delete</v-icon
                                            >
                                            Hapus Interpretasi
                                        </v-btn>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <v-card v-if="!data.length" outlined class="mb-3">
                <v-card-text>
                    <div align="center">Belum ada interpretasi</div>
                </v-card-text>
            </v-card>

            <v-btn
                class="align-center text-body-2 blew white--text mt-3"
                depressed
                @click="dialogRange = true"
            >
                <v-icon small class="pr-2">mdi-plus-circle</v-icon>
                Tambah Interpretasi
            </v-btn>

            <v-btn
                class="align-center text-body-2 mt-3 ml-2"
                depressed
                color="blew"
                outlined
                @click="dialogPotential = true"
            >
                <v-icon small class="pr-2">mdi-plus-circle</v-icon>
                Tambah Nama Interpretasi
            </v-btn>

            <v-card-actions class="mt-5">
                <v-spacer></v-spacer>
                <v-btn
                    @click="$emit('uncompleted', $attrs.data)"
                    depressed
                    text
                >
                    Kembali
                </v-btn>

                <v-btn
                    color="blew"
                    type="button"
                    class="btn btn-success pull-right"
                    depressed
                    dark
                    @click="backToScale()"
                >
                    Selesai
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog
            v-model="dialogRange"
            max-width="506px"
            @click:outside="dialogRange = false"
        >
            <dialogRange
                v-if="dialogRange"
                :scale="detail_scale"
                :detail="detail_range"
                @close="dialogRange = false"
                @save="saveRange()"
            />
        </v-dialog>

        <v-dialog
            v-model="dialogInterpretasi"
            max-width="506px"
            @click:outside="dialogInterpretasi = false"
        >
            <dialogInterpretasi
                v-if="dialogInterpretasi"
                :scale="detail_scale"
                :detail="detail_interpretasi"
                @close="dialogInterpretasi = false"
                @save="saveInterpretation()"
            />
        </v-dialog>

        <v-dialog
            v-if="dialogSubInterpretasi"
            v-model="dialogSubInterpretasi"
            max-width="506px"
            scrollable
            @click:outside="dialogSubInterpretasi = false"
        >
            <dialogSubInterpretasi
                :scale="detail_scale"
                :detail="detail_interpretasi"
                @save="saveInterpretation()"
                @close="dialogSubInterpretasi = false"
            />
        </v-dialog>

        <v-dialog v-model="confirmDialog" persistent max-width="490px">
            <v-card class="py-2">
                <v-card-title style="word-break: break-word !important">
                    Apakah anda akan menghapus interpretasi ini ?
                </v-card-title>
                <v-card-text> interpretasi ini akan dihapus. </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darkFade" text @click="confirmDialog = false">
                        Batal
                    </v-btn>
                    <v-btn
                        color="red"
                        dark
                        depressed
                        :loading="isLoadingForm"
                        @click="deleteItem()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-if="dialogPotential"
            v-model="dialogPotential"
            max-width="506px"
            scrollable
            persistent
        >
            <dialogPotential
                :scale="detail_scale"
                :detail="detail_interpretasi"
                @close="dialogPotential = false"
            />
        </v-dialog>
    </div>
</template>

<script>
import dialogInterpretasi from "./DialogInterpretasi.vue";
import dialogSubInterpretasi from "./DialogSubInterpretasi.vue";
import dialogRange from "./DialogRange.vue";
import dialogPotential from "./DialogPotential.vue";
import ambis_test from "../services/ambis_test";

export default {
    name: "interpretation-form",

    components: {
        dialogInterpretasi,
        dialogSubInterpretasi,
        dialogRange,
        dialogPotential,
    },

    data: function () {
        return {
            isLoading: false,
            isLoadingForm: false,
            selectedRow: null,
            confirmDialog: false,
            errors: [],
            show: true,
            showModal: false,
            dialogPage: false,
            dialogInterpretasi: false,
            dialogSubInterpretasi: false,
            dialogRange: false,
            dialogPotential: false,
            data: [],
            data_interpretasi: [],
            detail_scale: {},
            detail_range: {},
            detail_interpretasi: {},
            list_potential: [],
            data_potential: {},
            value_answer: [],
        };
    },

    mounted() {
        this.getListInterpretasi();
        this.getDetailScale();
    },

    methods: {
        getListInterpretasi() {
            var context = this;
            const scale_id =
                context.$route.query.scale_id || context.$attrs.data.id;

            ambis_test.getListInterpretasi(scale_id, function (result) {
                if (result) {
                    context.data = result.data;
                }
            });
        },

        getDetailScale() {
            var context = this;
            const scale_id =
                context.$route.query.scale_id || context.$attrs.data.id;

            ambis_test.getDetailScale(scale_id, function (result) {
                if (result.success) {
                    context.detail_scale = result.data;
                }
            });
        },

        saveRange() {
            this.dialogRange = false;
            this.getListInterpretasi();
        },

        editRange(data) {
            this.detail_range = data;
            this.dialogRange = true;
        },

        saveInterpretation() {
            this.dialogInterpretasi = false;
            this.dialogSubInterpretasi = false;
            this.getListInterpretasi();
        },

        addInterpretation(data) {
            this.detail_interpretasi = data;
            this.dialogInterpretasi = true;
        },

        editInterpretation(data) {
            this.detail_interpretasi = data;
            this.dialogInterpretasi = true;
        },

        addPage(page, data) {
            this.detail_interpretasi = data;
            this.detail_interpretasi.page = page;
            this.dialogSubInterpretasi = true;
        },

        addSubInterpretation(page, data) {
            this.detail_interpretasi = data;
            this.detail_interpretasi.page = page;

            this.dialogSubInterpretasi = true;
        },

        editSubInterpretation(data) {
            this.detail_interpretasi = data;
            this.dialogSubInterpretasi = true;
        },

        confirmDeleteItem(val) {
            this.selectedRow = val;
            this.confirmDialog = true;
        },

        deleteItem() {
            var context = this;
            const id = context.selectedRow.intrepretation_id;

            context.isLoadingForm = true;

            ambis_test.deleteInterpretation(id, function (result) {
                if (result.success) {
                    context.confirmDialog = false;
                    context.getListInterpretasi();
                    context.isLoadingForm = false;
                } else {
                    context.$store.commit("showAlert", {
                        message: `Gagal Menghapus Data!`,
                        type: "error",
                    });
                }
            });
        },

        previewPage() {
            this.$store.commit("showAlert", {
                message: `Preview belum dapat ditampilkan untuk saat ini`,
                type: "error",
            });
        },

        backToScale() {
            this.$router.replace({
                path: "/detail-skala",
                query: {
                    id: this.$route.query.theme_id,
                },
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// InterpretationForm.vue?1efd372e